// 订单状态
const OrderStatus = {
  // 1 付款之前
  BeforeInquiry: '11', // 待报价
  OnInquiry: '12', // 报价中
  BeforePayment: '13', // 待付款
  OnPayment: '130', // 等待买家付款
  // 2 付款
  AfterPayment: '21', // 已付款
  OnPaymentConfirm: '22', // 确认收款
  AfterPaymentConfirm: '23', // 已收款
  // 3 退款
  BeforeRefund: '31', // 退款审核中
  OnRefund: '32', // 退款中
  AfterRefund: '33', // 已退款
  // 4 生产状态
  BeforeProduce: '40', // 待打印
  OnProduce: '41', // 打印中
  BeforeDelivery: '420', // 待发货
  AfterDelivery: '42', // 已发货
  // 5 订单完结状态
  BeforeSign: '50', // 待收货
  BeforeCancel: '51', // 取消交易
  AfterCancel: '510', // 交易取消
  AfterSign: '52', // 已签收
  Succeed: '53', // 交易成功
  Finished: '54', // 订单完成
  Closed: '55' // 已关闭
}

export {
  OrderStatus
}



// WEBPACK FOOTER //
// ./src/plugins/Constant.js